module.exports = __webpack_public_path__ + "img/pt.88f405a4.svg";